import React, { useState } from 'react';
import styled from 'styled-components';

const ContactContainer = styled.section`
  padding: 60px 20px;
  background: #f5f9fc;
  font-family: 'Merriweather', serif;
  color: #333;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.8rem;
  color: #22577a;
  margin-bottom: 40px;
`;

const Form = styled.form`
  max-width: 700px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
`;

const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 25px;
  font-size: 1rem;

  &:focus {
    border-color: #22577a;
    outline: none;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  height: 150px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  margin-bottom: 25px;

  &:focus {
    border-color: #22577a;
    outline: none;
  }
`;

const SubmitButton = styled.button`
  background-color: #22577a;
  color: #fff;
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #183f5e;
  }
`;

const SuccessMessage = styled.p`
  text-align: center;
  margin-top: 20px;
  color: green;
`;

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can connect this to your API
    console.log(formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <ContactContainer>
      <Title>Contáctanos</Title>
      <Form onSubmit={handleSubmit}>
        <Label htmlFor="name">Nombre</Label>
        <Input
          type="text"
          name="name"
          id="name"
          placeholder="Tu nombre"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <Label htmlFor="email">Correo electrónico</Label>
        <Input
          type="email"
          name="email"
          id="email"
          placeholder="tucorreo@ejemplo.com"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <Label htmlFor="message">Mensaje</Label>
        <TextArea
          name="message"
          id="message"
          placeholder="Escribe tu mensaje aquí..."
          value={formData.message}
          onChange={handleChange}
          required
        />

        <SubmitButton type="submit">Enviar</SubmitButton>
        {submitted && <SuccessMessage>¡Gracias por tu mensaje!</SuccessMessage>}
      </Form>
    </ContactContainer>
  );
};

export default Contact;
